import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, CustomDirectiveConfig, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, PrimeNgTableVariablesModel, ReusablePrimeNGTableFeatureService, RxjsService, currentComponentPageBasedPermissionsSelector$, getPDropdownData, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { MomentService } from '@app/shared/services/moment.service';
import { TicketManualAddModel } from '@modules/customer/models';
import { CUSTOMER_COMPONENT } from '@modules/customer/shared';
import { loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { UserModuleApiSuffixModels } from '@modules/user/shared';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest, forkJoin } from 'rxjs';


@Component({
  selector: 'app-all-tickets-list',
  templateUrl: './all-tickets-list.component.html',
  styleUrls: ['./all-tickets-list.component.scss']
})
export class AllTicketsListComponent extends PrimeNgTableVariablesModel implements OnInit {
  selectedRow: any;
  serviceMappingId: any;
  ticketForm: any;
  ticketTypeList = [];
  ticketGroupList = [];
  assigntoList = [];
  selectedOptions: any = [];
  ticketStatusList: any = [];
  showFilterForm: boolean = false;
  ticketPriorityList: any;
  ticketdetails: any;
  filterData: any;
  groupId: string;
  book1: any;
  fromDate: any = new Date();
  todayDate: any = new Date();
  isNumberOnly = new CustomDirectiveConfig({ isANumberOnly: true });
  startTodayDate = 0;
  filterParams;
  isShowNoRecord = false;
  primengTableConfigProperties: any = {
    tableCaption: "Tickets",
    shouldShowBreadCrumb: false,
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'Customers Management', relativeRouterUrl: '/customer/dashboard' }, { displayName: 'Ticket List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Tickets',
          dataKey: 'ticketId',
          enableBreadCrumb: true,
          enableAction: true,
          enableScrollable: true,
          enableFieldsSearch: true,
          enableHyperLink: true,
          cursorLinkIndex: 0,
          enableSecondHyperLink: true,
          cursorSecondLinkIndex: 4,
          columns: [
            { field: 'ticketRefNo', header: 'Ticket ID' },
            { field: 'regionName', header: 'Region' },
            { field: 'branchName', header: 'Branch' },
            { field: 'ticketTypeName', header: 'Action Type' },
            { field: 'userGroupName', header: 'User Group' },
            { field: 'assignedToName', header: 'Assigned To' },
            { field: 'customerName', header: 'Customer' },
            { field: 'createdDate', header: 'Created Date', isDateTime: true, width: '150px' },
            { field: 'lapsedTime', header: 'Lapsed Time' },
            { field: 'ticketStatusName', header: 'Status', type: 'dropdown', options: [] }
          ],
          apiSuffixModel: SalesModuleApiSuffixModels.ALL_TICKETS,
          moduleName: ModulesBasedApiSuffix.SALES,
          shouldShowFilterActionBtn: true,

        }]
    }
  }
  ticketFlagList: any;
  userGroupIds: any = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private crudService: CrudService, public dialogService: DialogService, private store: Store<AppState>,
    private momentService: MomentService, private router: Router, private rxjsService: RxjsService, private formBuilder: FormBuilder, private datePipe: DatePipe,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService) {
    super();
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getList();
    this.createTicketManualAddForm();
    forkJoin([
      this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_UX_TICKETTYPES, undefined, true, null, 1),
      this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_GROUPS, undefined, true),
      this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKET_PRIORITY, undefined, true),
      this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UX_TICKETSTATUS, undefined, true, null, 1)
    ]).subscribe(([typesRes, groupRes, priorityRes, statusRes]: IApplicationResponse[]) => {
      if (typesRes.isSuccess && typesRes.statusCode == 200 && typesRes.resources) {
        this.ticketTypeList = typesRes.resources;
      }
      if (groupRes.isSuccess && groupRes.statusCode == 200 && groupRes.resources) {
        this.ticketGroupList = groupRes.resources;
      }
      if (priorityRes.isSuccess && priorityRes.statusCode == 200 && priorityRes.resources) {
        this.ticketPriorityList = priorityRes.resources;
      }
      if (statusRes.isSuccess && statusRes.statusCode == 200 && statusRes.resources) {
        this.ticketStatusList = statusRes.resources;
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns[7]['options'] = getPDropdownData(statusRes.resources, 'displayName', 'displayName');
      }
      if (this.data.ticketId) {
        this.getTicketById(this.data.ticketId);
      }
    });
  }
  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][CUSTOMER_COMPONENT.TICKETS]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }
  createTicketManualAddForm(TicketModelData?: TicketManualAddModel): void {
    let ticketModel = new TicketManualAddModel(TicketModelData);
    this.ticketForm = this.formBuilder.group({});
    Object.keys(ticketModel).forEach((key) => {
      this.ticketForm.addControl(key, new FormControl(TicketManualAddModel[key]));
    });
  }

  getTicketById(ticketId: string) {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKETS, this.data.ticketId, false, null, 1)
      .subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode == 200) {
          this.ticketdetails = response.resources;
          this.ticketForm.patchValue(this.ticketdetails);
          this.getassignedto(this.ticketdetails.userGroupId);
        } else {
          this.ticketdetails = null;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  getassignedto(id: any) {
    this.crudService.create(ModulesBasedApiSuffix.SALES, UserModuleApiSuffixModels.UX_ASSINGN_TO, { groupIds: id.toString() }).subscribe((response: IApplicationResponse) => {
      this.rxjsService.setDialogOpenProperty(false);
      if (response.statusCode == 200) {
        this.assigntoList = response.resources;
      }
    });
  }

  getFlagColor() {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKET_FLAG, undefined, true).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.ticketFlagList = response.resources;
      }
    });
  }

  OnUserGroupChange(event: any) {
    this.userGroupIds = [];
    event?.value?.forEach(res => {
      this.userGroupIds.push(res?.id);
    })
    this.groupId = this.userGroupIds;
    if (this.groupId.length > 0) {
      this.getassignedto(this.groupId);
      this.rxjsService.setGlobalLoaderProperty(false);
    }
  }
  getTicketsCounts(pageIndex?: string, pageSize?: string, otherParams?: object, isFilter = false) {
    let salesModuleApiSuffixModels: SalesModuleApiSuffixModels;
    salesModuleApiSuffixModels = isFilter == true ? SalesModuleApiSuffixModels.ALL_FILTERED_TICKETS_COUNTS: SalesModuleApiSuffixModels.SALES_API_ALL_TICKETS_COUNT;
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      salesModuleApiSuffixModels, undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.totalRecords = response?.resources?.totalCount || 0
        }
      });
  }

  getList(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.getTicketsCounts(pageIndex, pageSize, otherParams)
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.ALL_TICKETS,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources;
        this.dataList.forEach(ele => {
          ele.isUpdateFlag = false;
        });
        this.loading = false;
        this.isShowNoRecord = this.dataList.length == 0 ? true : false

      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });;
  }

  getListFilter(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.getTicketsCounts(pageIndex,pageSize,otherParams,true)
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.ALL_FILTERED_TICKETS,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources;
        this.dataList.forEach(ele => {
          ele.isUpdateFlag = false;
        });
        this.loading = false;
        this.isShowNoRecord = this.dataList.length ==0 ? true:false

      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });;
  }
  showFlag(data) {
    this.dataList.forEach(ele => {
      if (ele.ticketId == data.ticketId) {
        ele.isUpdateFlag = true;
      } else {
        ele.isUpdateFlag = false;
      }
    });
  }

  updateFlag(dt, rowData) {
    let formData = {
      "ticketId": rowData.ticketId,
      "flagColorId": dt.id,
      "modifiedUserId": this.loggedInUserData.userId
    }
    this.crudService.update(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.FLAG_UPDATE, formData, 1)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.getList();
        }
      });
  }

  onCRUDRequesteds(type: CrudType | string, row?: object, field?: any): void {
    if (field) {
      switch (field) {
        case "ticketRefNo":
          this.router.navigate(['/customer/manage-customers/ticket/view'], { queryParams: { id: row['ticketId'], customerId: row['customerId'], fromComponent: "Tickets", addressId:row['addressId'] } });
          break;
        case "customerName":
          this.rxjsService.setViewCustomerData({
            customerId: row['customerId'],
            addressId: row['addressId'],
            customerTab: 0,
            monitoringTab: null,
          })
          this.rxjsService.navigateToViewCustomerPage();
          break;
        case "filter":
          this.displayAndLoadFilterData();
          break;
        case CrudType.GET:
          this.row = row ? row : { pageIndex: 0, pageSize: 10 };
          field = { ...this.filterData, ...field }
          if (field?.ticketTypeName)
            field.ticketType = field.ticketTypeName;
          if (field && field['createdDate']) {
            field['createdDate'] = (field['createdDate'] && field['createdDate'] != null) ? this.momentService.toMoment(field['createdDate']).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
          }
          this.getList(row["pageIndex"], row["pageSize"], field)
          break;
      }
    } else {
      let otherParams = {};
      if (CrudType.GET === type && Object.keys(row).length > 0) {
        // logic for split columns and its values to key value pair
        Object.keys(row['searchColumns']).forEach((key) => {
          otherParams[key] = row['searchColumns'][key]['value'];
        });
        otherParams['sortOrder'] = row['sortOrder'];
        if (row['sortOrderColumn']) {
          otherParams['sortOrderColumn'] = row['sortOrderColumn'];
        }
      }
      switch (type) {
        case CrudType.CREATE:
          this.openAddEditPage(CrudType.CREATE, row);
          break;
        case CrudType.GET:
          switch (this.selectedTabIndex) {
            case 0:
              if (otherParams && otherParams['ticketTypeName'])
                otherParams['ticketType'] = otherParams['ticketTypeName'];
              if (otherParams && otherParams['userGroupName'])
                otherParams['userGroup'] = otherParams['userGroupName'];
              if (otherParams && otherParams['assignedToName'])
                otherParams['assignedTo'] = otherParams['assignedToName'];
              if (otherParams && otherParams['createdDate']) {
                otherParams['createdDate'] = (otherParams['createdDate'] && otherParams['createdDate'] != null) ? this.momentService.toMoment(otherParams['createdDate']).format('YYYY-MM-DDThh:mm:ss[Z]') : null;
              }
              this.getList(
                row["pageIndex"], row["pageSize"], otherParams);
              break;
          }
          break;
        case CrudType.EDIT:
          this.openAddEditPage(CrudType.EDIT, row);
          break;
        case "applyFilter":
          if (this.filterData?.ticketTypeName)
            this.filterData.ticketType = field.ticketTypeName;
          this.getListFilter(row["pageIndex"], row["pageSize"], this.filterData)
          break;
      }
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        this.router.navigate(['customer/action-types/add-edit'], { skipLocationChange: true });
        break;
      case CrudType.EDIT:
        this.router.navigate(['/customer/manage-customers/ticket/view'], { queryParams: { id: editableObject['ticketId'], customerId: editableObject['customerId'] } });
        break;
    }
  }

  displayAndLoadFilterData() {
    this.showFilterForm = !this.showFilterForm;
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.GET:
        this.row = row;
        unknownVar = { ...unknownVar, ...  this.filterParams };
        this.getList(row["pageIndex"], row["pageSize"], unknownVar);
        break;
      case CrudType.VIEW:
        this.router.navigate(['/customer/manage-customers/ticket/view'], { queryParams: { id: row['ticketId'], customerId: row['customerId'], fromComponent: "Tickets", addressId: row['addressId'] } });
        break;
      case CrudType.EDIT:
        this.rxjsService.setViewCustomerData({
          customerId: row['customerId'],
          addressId: row['addressId'],
          customerTab: 0,
          monitoringTab: null,
        })
        this.rxjsService.navigateToViewCustomerPage();
        break;
      case CrudType.FILTER:
        this.displayAndLoadFilterData();
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeStatus(rowData?, index?) {
    this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
      this.primengTableConfigProperties, rowData)?.onClose?.subscribe((result) => {
        if (!result) {
          this.dataList[index].isActive = this.dataList[index].isActive ? false : true;
        }
      });
  }

  change(value) {
    let row = {};
    row['pageIndex'] = 0;
    row["pageSize"] = 10;
    this.onCRUDRequested(CrudType.GET, this.row)
  }

  onSubmit() {
    let assignedToMultipleArr = [];
    let ticketStatusNameMultipleArr = [];
    this.ticketForm.get('assignedToMultiple')?.value?.forEach(result => { assignedToMultipleArr.push(result?.displayName) });
    this.ticketForm.get('ticketStatusNameMultiple')?.value?.forEach(result => {
      ticketStatusNameMultipleArr.push(result?.displayName);
    })
    this.filterData = Object.assign({},
      this.ticketForm.get('ticketTypeMultiple').value == '' ? null : { ticketTypeMultiple: this.ticketForm.get('ticketTypeMultiple').value },
      this.ticketForm.get('userGroupMultiple').value == '' ? null : { userGroupMultiple: this.ticketForm.get('userGroupMultiple').value },
      this.ticketForm.get('assignedToMultiple').value == '' ? null : { assignedToMultiple: assignedToMultipleArr },
      this.ticketForm.get('createdStartDate').value ? { createdStartDate: this.datePipe.transform(this.ticketForm.get('createdStartDate').value, 'yyyy-MM-dd') } : null,
      this.ticketForm.get('createdEndDate').value ? { createdEndDate: this.datePipe.transform(this.ticketForm.get('createdEndDate').value, 'yyyy-MM-dd') } : null,
      this.ticketForm.get('closedStartDate').value ? { closedEndDate: this.datePipe.transform(this.ticketForm.get('closedStartDate').value, 'yyyy-MM-dd') } : null,
      this.ticketForm.get('closedEndDate').value ? { closedEndDate: this.datePipe.transform(this.ticketForm.get('closedEndDate').value, 'yyyy-MM-dd') } : null,
      this.ticketForm.get('lapsedStartTime').value ? { lapsedStartTime: Number(this.ticketForm.get('lapsedStartTime').value) } : null,
      this.ticketForm.get('lapsedEndTime').value ? { lapsedEndTime: Number(this.ticketForm.get('lapsedEndTime').value) } : null,
      this.ticketForm.get('ticketStatusNameMultiple').value == '' ? null : { ticketStatusNameMultiple: ticketStatusNameMultipleArr },
    );
    if (this.filterData.ticketStatusNameMultiple) {
      this.filterData.ticketStatusNameMultiple = this.filterData.ticketStatusNameMultiple.toString();
    }
    let userGroupMultipleArr = [];
    if (this.filterData.userGroupMultiple) {
      this.filterData.userGroupMultiple.forEach(element => {
        let data = this.ticketGroupList.filter(x => x.id == element?.id);
        userGroupMultipleArr.push(data[0].displayName);
      });
      this.filterData.userGroupMultiple = userGroupMultipleArr;
    }
    Object.keys(this.filterData).forEach(key => {
      if (this.filterData[key] == '' || this.filterData[key] == null) {
        delete this.filterData[key]
      }
    });
    let row = {};
    row['pageIndex'] = 0;
    row["pageSize"] = 10;
    this.filterParams = this.filterData;
    this.onCRUDRequesteds('applyFilter', row, null);
    this.showFilterForm = !this.showFilterForm;
  }

  resetForm() {
    this.ticketForm.reset();
    this.row['pageIndex'] = 0;
    this.row['pageSize'] = 10;
    this.filterData = null; this.filterParams = null;
    this.getList(this.row['pageIndex'], this.row['pageSize'], null);
    this.showFilterForm = !this.showFilterForm;
  }
}
